export default function OrDivider() {
  return (
    <div className="flex items-center my-3 w-[300px] px-1">
      <div className="flex-grow border-t border-gray-300 dark:border-slate-600" />
      <span className="mx-4 text-gray-600 dark:text-slate-400">OR</span>
      <div className="flex-grow border-t border-gray-300 dark:border-slate-600" />
    </div>
  )
}
